// export for HubspotForm.tsx & HubspotFormPopup.tsx
export interface HubspotFormProps {
  hubspotFormId: string
  hubspotPortalId?: string
  consent?: React.ReactNode
  redirect?: string
  submittedBlock?: React.ReactNode
  withGrayBackground?: boolean
  halfScreenWidth?: boolean
  isCentered?: boolean
  fullWidthButton?: boolean
  blackBG?: boolean
  submitOnRight?: boolean
  buttonType?: string
  withWhiteBackground?: boolean
  cssStyles?: string
}

// export for HubspotForm.tsx
interface HubSpotFormParams {
  portalId: string
  formId: string
  target: string
  redirectUrl?: string
  submitButtonClass?: string
  cssClass?: string
  onReady?: (form: HTMLFormElement) => void
}

export interface HubSpotFormApi {
  forms: {
    create: (params: HubSpotFormParams) => void
  }
}

// export for useHsFormCallback.ts (useHsFormCallback)
export type UseHsMeetingCallbackParams = {
  onMeetingBooked?: (event: MessageEvent) => void
  deps?: any[]
}

interface HsFormMessageData {
  type: 'hsFormCallback'
  id: string
  eventName: 'onFormSubmitted' | 'onFormReady' | 'onFormSubmit'
}

// export for useHsFormCallback.ts (useHsMeetingCallback)
interface HsMeetingMessageData {
  meetingBookSucceeded: boolean
}

export function isHsMeetingMessageData(data: any): data is HsMeetingMessageData {
  return data && typeof data.meetingBookSucceeded === 'boolean'
}

export function isHsFormMessageData(data: any): data is HsFormMessageData {
  return data && data.type === 'hsFormCallback' && typeof data.id === 'string' && typeof data.eventName === 'string'
}

// export for LeftCornerPopup.tsx (messageHandler)
interface HsFormSubmitMessageData {
  type: 'hsFormCallback'
  eventName: 'onFormSubmit'
  id: string
  data: any // The payload for the setUser state is still unknown here
}

export function isHsFormSubmitMessageData(data: any): data is HsFormSubmitMessageData {
  // We disable these rules because this function's job is to intentionally
  // inspect an 'any' type to validate its shape.

  return data && data.type === 'hsFormCallback' && data.eventName === 'onFormSubmit' && typeof data.id === 'string'
}

// export for HubspotCalender.tsx
interface HsMeetingContact {
  email: string
}

interface HsMeetingPostResponse {
  contact: HsMeetingContact
}

interface HsMeetingBookingResponse {
  postResponse: HsMeetingPostResponse
}

interface HsMeetingPayload {
  bookingResponse: HsMeetingBookingResponse
}

interface HsCalendarMessageData {
  meetingsPayload: HsMeetingPayload
}

export function isHsCalendarMessageData(data: any): data is HsCalendarMessageData {
  // We disable these rules because this function's job is to intentionally
  // inspect an 'any' type to validate its shape.

  return typeof data?.meetingsPayload?.bookingResponse?.postResponse?.contact?.email === 'string'
}

// export for ContactSalesBlock.tsx
interface HubSpotFormField {
  name: string
  value: string
}

interface HsFormWithDataPayload {
  type: 'hsFormCallback'
  eventName: 'onFormSubmit'
  id: string
  data: HubSpotFormField[]
}

export function isHsFormWithData(data: any): data is HsFormWithDataPayload {
  // We disable these rules because this function's job is to intentionally
  // inspect an 'any' type to validate its shape.

  return data && data.type === 'hsFormCallback' && data.eventName === 'onFormSubmit' && Array.isArray(data.data)
}
